(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu-secondary"] && !Shopify.designMode) return;
  try {
    class NavTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelectorAll('.nav-link').forEach(link => {
        link.addEventListener('click', this.clickHandler.bind(this), false);
      });
    }

    clickHandler(ev) {
      if (!ev.currentTarget.classList.contains('active')) {
        this.querySelectorAll('.nav-link').forEach(link => {
          link.classList.remove('active');
        });

        ev.currentTarget.classList.add('active');
        const tab = ev.currentTarget.getAttribute('aria-controls');
        this.querySelector('.tab-pane.active').classList.remove('active', 'show');
        document.getElementById(tab).classList.add('active');
        setTimeout(() => {
          document.getElementById(tab).classList.add('show');
        }, 100);
      }
    }
  }
  customElements.define('nav-tabs', NavTabs);
  } catch(e) { console.error(e); }
})();

})();
